import { apiRequest } from './client';
import type {
  CreateShiftCloseInput,
  CreateShiftCloseResult,
  ShiftCloseDetailResponse,
  ShiftCloseListFilters,
  ShiftCloseListResponse,
  ShiftClosePreview,
  ShiftClosePreviewFilters,
  ShiftCloseReconciliation,
  ShiftDailySummaryFilters,
  ShiftDailySummaryResponse,
  VoidShiftCloseInput,
  VoidShiftCloseResult,
} from '../types/shifts';
import type { CoveringShiftClose, ShiftCashBreakdown, ShiftCashBreakdownFilters } from '../types/shiftCashBreakdown';

const PATH = '/api/shifts';

export const getShiftClosePreview = (filters: ShiftClosePreviewFilters) => apiRequest<ShiftClosePreview>(`${PATH}/close-preview${toQuery(filters)}`);
export const createShiftClose = (input: CreateShiftCloseInput) => apiRequest<CreateShiftCloseResult>(`${PATH}/closes`, json('POST', input));
export const getShiftCloses = (filters: ShiftCloseListFilters = {}) => apiRequest<ShiftCloseListResponse>(`${PATH}/closes${toQuery(filters)}`);
export const getShiftCloseDetail = (shiftCloseId: string) => apiRequest<ShiftCloseDetailResponse>(`${PATH}/closes/${shiftCloseId}`);
export const voidShiftClose = (shiftCloseId: string, input: VoidShiftCloseInput) => apiRequest<VoidShiftCloseResult>(`${PATH}/closes/${shiftCloseId}/void`, json('POST', input));
export const reconcileShiftClose = (shiftCloseId: string) => apiRequest<ShiftCloseReconciliation>(`${PATH}/closes/${shiftCloseId}/reconcile`);
export const getShiftDailySummary = (filters: ShiftDailySummaryFilters) => apiRequest<ShiftDailySummaryResponse>(`${PATH}/daily-summary${toQuery(filters)}`);
// Detalle del turno (solo lectura): de dónde sale el efectivo esperado, peso por peso.
export const getShiftCashBreakdown = (filters: ShiftCashBreakdownFilters) => apiRequest<ShiftCashBreakdown>(`${PATH}/cash-breakdown${toQuery(filters)}`);
export const getShiftCloseCashBreakdown = (shiftCloseId: string) => apiRequest<ShiftCashBreakdown>(`${PATH}/closes/${shiftCloseId}/cash-breakdown`);
/** ¿Un corte cerrado ya contó este movimiento? Devuelve { close: null } cuando no (el caso normal). */
export const getCoveringShiftClose = (filters: { storeId: string; at: string }) => apiRequest<{ close: CoveringShiftClose | null }>(`${PATH}/closes/covering${toQuery(filters)}`);

function json(method: string, body: unknown): RequestInit {
  return { method, body: JSON.stringify(body) };
}

function toQuery(filters: object) {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => { if (value !== undefined && value !== '') query.set(key, String(value)); });
  // Sin `URLSearchParams.size`: no existe en Chromium 83, el WebView de Android 11 (Bloque G).
  const search = query.toString();
  return search ? `?${search}` : '';
}
